// Import the functions you need from the SDKs you need
import {
  getAnalytics,
  isSupported as isSupportedAnalytics,
} from '@firebase/analytics'
import { initializeApp } from '@firebase/app'
import {
  getRemoteConfig,
  isSupported as isSupportedRemote,
} from '@firebase/remote-config'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyCKXV2uUkO2wVgW3YaeEjHIL0i0xwgpmKs',
  authDomain: 'pixydocs.firebaseapp.com',
  projectId: 'pixydocs',
  storageBucket: 'pixydocs.appspot.com',
  messagingSenderId: '574597456348',
  appId: '1:574597456348:web:48476e0e6a987616532f19',
  measurementId: 'G-C4ZNPLJYJB',
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

export const analytics = async () =>
  (await isSupportedAnalytics()) && getAnalytics(app)

// FeatureFlagProvider loads this file at app boot. The messaging SDK is
// imported inside the function, not at the top of the file, so it only
// loads for browsers that use push instead of shipping in the boot bundle.
export const messaging = async () => {
  const { getMessaging, isSupported } = await import('@firebase/messaging')
  return (await isSupported()) ? getMessaging(app) : null
}

export const remoteConfig = async () => {
  const supported = await isSupportedRemote()
  if (supported) {
    const remoteConfig = getRemoteConfig(app)
    // Only for development
    if (
      import.meta.env.VITE_ENVIRONMENT !== 'stage' &&
      import.meta.env.VITE_ENVIRONMENT !== 'prod'
    ) {
      remoteConfig.settings.minimumFetchIntervalMillis = 0
    } else {
      remoteConfig.settings.minimumFetchIntervalMillis = 1000 * 60 * 10 // ten minutes
    }

    return remoteConfig
  }
  return null
}
